function getUrlVars() {
  var vars = [], hash;
  var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  for (var i = 0; i < hashes.length; i++) {
    hash = hashes[i].split('=');
    vars.push(hash[0]);
    vars[hash[0]] = hash[1];
  }
  return vars;
}

function addColonToTime(timeSlot) {
  // console.log(timeSlot);
  const timeslotString = String(timeSlot);
  // console.log(timeslotString);
  return timeslotString.substring(0, timeslotString.length - 2) + ':' + timeslotString.slice(-2);
}

function addLeadingZeroToMilitaryTimeIfNeeded(timeSlot) {
  return timeSlot.length === 3 ? 0 + timeSlot : timeSlot;
}
